import { gql } from 'apollo-boost';


export const GET_NEWS = gql`
    query getNews($year: String!) {
        news(year: $year) {
            uid
            type
            date
            title
            description
            year
            cover {
                type
                filename
                url
            }
            media {
                type
                filename
                url
            }
            project {
                external
            }
            recruit {
                recipient
            }
            end {
                category
            }
        }
    } 
`;
